module.exports = __webpack_public_path__ + "static/media/soles_for_souls.c85fa168.png";